import typeOf from '../typeOf.js';

const type = 'undefined';

export default {
  type: type,
  is: function (value) {
    return typeOf(value) === type;
  },
  isNot: function (value) {
    return typeOf(value) !== type;
  },
  isNotEmpty: function (value) {
    if (typeOf(value) === 'string') {
      return value.trim() !== '';
    }

    return true;
  }
}